import { valBoolean, valSchema, valString } from '@bymason-private/legacy-pattern-components';
import { CreateAccountOptions } from '@bymason-private/controller-api-hooks';

export interface FormData extends Omit<CreateAccountOptions, 'legal'> {
  consented: boolean;
}
export type FormFields = keyof FormData;

export enum Fields {
  FirstName = 'firstname',
  LastName = 'lastname',
  Company = 'companyName',
  Email = 'email',
  Password = 'password',
  CommunicationConsented = 'consented',
}

const REQUIRED_MSG = 'This is a required field';

export const schema = valSchema().shape({
  [Fields.FirstName]: valString().noLeadWhitespace().required(REQUIRED_MSG),
  [Fields.LastName]: valString().noLeadWhitespace().required(REQUIRED_MSG),
  [Fields.Company]: valString().noLeadWhitespace().required(REQUIRED_MSG),
  [Fields.Email]: valString().email(getInvalidMessage(Fields.Email)).required(REQUIRED_MSG),
  [Fields.Password]: valString().required(REQUIRED_MSG),
  [Fields.CommunicationConsented]: valBoolean(),
});

//
//
// helpers
//
//

function getInvalidMessage(field: Fields) {
  return `Invalid ${field}`;
}
